import { Grid, Paper, Box, styled, Typography } from '@mui/material';
import globals from '../globals';
import EditCourseTF from '../components/course_edit/tf';
import RTE from '../components/course_edit/rich_text_editor';
import FileUpload from "../components/course_edit/button_upload_file";
import RedButton from '../components/redButton';
import BlueButton from '../components/blueButton';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useParams } from 'react-router-dom';
import LoadingIcon from '../components/loading';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    // textAlign: 'center',
    // color: (theme.vars ?? theme).palette.text.secondary,
    // ...theme.applyStyles('dark', {
    //     backgroundColor: '#1A2027',
    // }),
}));


const MaterialsUploadPage = ({ courseId, title, description, materials, uploadId, student_id, addMaterial, assignmentId }) => {
    const { token } = useAuth();
    const [localTitle, setLocalTitle] = useState(title || '');
    const [localDescription, setLocalDescription] = useState(description || '');
    const [localMaterials, setLocalMaterials] = useState(materials || []);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const isUpdate = title != '' && title != null;

    const handleTitle = (e) => {
        setLocalTitle(e.target.value);
    }

    const handleDescriptionChange = (e) => {
        setLocalDescription(e.target.value);
    }

    const handleMaterialsChange = (files) => {
        setLocalMaterials(files);
    }

    const clear = () => {
        setLocalTitle('');
        setLocalDescription('');
        setLocalMaterials([]);
    }

    const handleSave = (event) => {
        event.preventDefault();
        // event.target.disabled = true;
        setLoading(true);
        //console.log(localTitle, localDescription, localMaterials);
        const formData = new FormData();
        formData.append('data', JSON.stringify({ student_id: student_id, title: localTitle, description: localDescription }));
        // formData.append('files', localMaterials);
        //console.log('isUpdate', isUpdate);
        if (!isUpdate) {
            for (const file of localMaterials) {
                formData.append('files', file);
            }
        }
        else {
            if (localMaterials.toString() != materials.toString()) {
                for (const file of localMaterials) {
                    formData.append('files', file);
                }
            }
        }



        fetch(`${globals.apiUrl}/courses/assignments/${isUpdate ? assignmentId : courseId}`, {
            method: isUpdate ? 'PUT' : 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
                // 'Content-Type': 'application/json',
            },
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setLoading(false);
                if (data.detail){
                    setShowSuccess(false);
                    throw new Error(data.detail);
                }
                else {
                    setShowSuccess(true);
                    if (addMaterial) {
                    clear();
                    addMaterial({id: data.id, title: data.title, description: data.description, materials: data.materials, submission: []});
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    const handleCancel = () => {
        //console.log(localTitle, localDescription, localMaterials);
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
                <Item elevation={4}>
                    <Grid item sm={12} xs={12}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 17 }}>Име на темата:</Typography>
                    </Grid>
                    <Grid item>
                        <EditCourseTF numRows={0} rowsMax={0} width={'60vw'} defaultValue={localTitle} onChange={handleTitle} />
                    </Grid>
                    <Grid item sm={12} xs={12} sx={{ mt: 3, mb: 1 }}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 17 }}>Описание на тема: </Typography>
                    </Grid>
                    <Grid item>
                        <RTE defaultValue={localDescription} onChange={handleDescriptionChange} />
                    </Grid>
                    <Grid item sm={12} xs={12} sx={{ mt: 3, mb: 1 }}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 17 }}>Материали: (напр. PDF файл)  </Typography>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <FileUpload helpText={'Прикачи файл'} id={uploadId || 'fileUploadId'} uploadedFiles={materials} onChange={handleMaterialsChange} />
                    </Grid>
                    <Grid item sm={12} xs={12} sx={{ mt: 3, mb: 1 }}>
                        <Grid container spacing={3}>
                            <Grid item>
                                <RedButton text={'Запази'} pX={3} onClick={handleSave} />
                            </Grid>
                            <Grid item>
                                <BlueButton text={'Отказ'} px={3} onClick={handleCancel} />
                            </Grid>
                            {loading && <Grid item>
                                <LoadingIcon />
                            </Grid>}

                        </Grid>
                    </Grid>
                </Item>
            </Grid>
        </Box>
    );
}

export default MaterialsUploadPage